import { buildVendorDeviceMetaWatchFields } from '../../components/vendorDevice';
import type { ResourceConfigEntry, ResourceType, SkuModuleMeta } from '../../platform/pipeline-kernel/types';

export const vcpu: ResourceType = {
  requirement: '',
  code: 'vCPU',
  description: 'CPU',
  unit: 'Core',
};

export const memory: ResourceType = {
  requirement: '',
  code: 'Memory',
  description: 'Memory',
  unit: 'Gi',
};

export const gpu: ResourceType = {
  requirement: '',
  code: 'vGPU',
  description: 'GPU',
  unit: 'Card',
};

export const systemDiskSize: ResourceType = {
  requirement: '',
  code: 'SystemVolume',
  description: 'System Volume',
  unit: 'Gi',
};

export const dataVolume: ResourceType = {
  requirement: '',
  code: 'DataVolume',
  description: 'Data Volume',
  unit: 'Gi',
};

export const computeTemplates = { vcpu, memory, gpu };

/** 节点组 JSON / 外部容器副本变更须触发算价 */
const APP_NODE_REPLICA_WATCH_FIELDS = ['masterNodes', 'workerNodes', 'runMode', 'replicas'] as const;

/** Legacy 计价条目定义；SKU/下单切流量后由 useResourceFieldChange 消费 */
export const APP_INSTANCE_RESOURCE_CONFIGS: ResourceConfigEntry[] = [
  {
    ...vcpu,
    watchFields: [...APP_NODE_REPLICA_WATCH_FIELDS],
    displayIds: ['compute-cpu-total'],
  },
  {
    ...memory,
    watchFields: [...APP_NODE_REPLICA_WATCH_FIELDS],
    displayIds: ['compute-memory-total'],
  },
  {
    ...gpu,
    watchFields: [...APP_NODE_REPLICA_WATCH_FIELDS],
    displayIds: ['compute-gpu-total'],
  },
  {
    ...systemDiskSize,
    watchFields: [
      'master.systemDiskSize',
      'worker.systemDiskSize',
      ...buildVendorDeviceMetaWatchFields('masterSystemDiskPricing'),
      ...buildVendorDeviceMetaWatchFields('workerSystemDiskPricing'),
      ...APP_NODE_REPLICA_WATCH_FIELDS,
    ],
    displayIds: ['system-volume'],
  },
  {
    ...dataVolume,
    watchFields: ['_appStorageGroups'],
    displayIds: ['shared-storage-total'],
  },
  {
    requirement: '',
    code: 'DisplayMeta',
    description: 'Display Meta',
    pricing: false,
    watchFields: ['_inferenceSystem', 'maasInferenceSource', 'runMode'],
    displayIds: ['app_image_source', 'app_image', 'deploy_mode'],
  },
];

/**
 * SKU 模块元信息（与直建/SKU UI 模块 key 对齐）。
 * 注意：旧 pages `legacySkuModuleMeta` 曾误用 storage.presetCheckFields=['volumes']，以此处为准。
 */
export const APP_INSTANCE_SKU_MODULE_META: Record<string, SkuModuleMeta> = {
  runtimeConfig: {
    resource: false,
    presetCheckFields: ['runtime.type'],
  },
  appService: {
    resource: false,
    presetCheckFields: ['_inferenceSystem', 'inferenceFrameworkImage'],
  },
  envVars: {
    resource: false,
    presetCheckFields: ['commonEnv'],
    orderListItemLock: true,
  },
  service: {
    resource: false,
    presetCheckFields: ['_inferenceService', '_serviceMountGroupName'],
    orderListItemLock: true,
  },
  healthCheck: {
    resource: false,
    presetCheckFields: ['_containerDeployHealthCheck'],
  },
  nodeGroups: { resource: true },
  storage: {
    resource: true,
    presetCheckFields: ['_appStorageGroups', 'dataMountPath'],
  },
};
